import React from 'react';
import toast from 'react-hot-toast';
import {
    Grid,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';

import {
    Select,
    SecondaryButton
} from "../../Common"

import { trakrefFontFamilySemiBold } from '../../../utils';
import { Grey3 } from "../../../color_utils";

const Assets = ({ initialState, assets, setAssets, options }) => {

    const onExpand = (currentIndex, isExpanded) => {
        if (currentIndex <= -1)
            return;

        const newAssets = assets.map((asset, index) => ({
            ...asset,
            isOpen: currentIndex === index ? isExpanded : false
        }));

        setAssets(newAssets);
    }

    const onAdd = () => {
        const newAssets = assets.map(asset => ({
            ...asset,
            hasError: asset.assetId ? false : true,
            isOpen: asset.assetId ? false : true
        }));

        if (newAssets.filter(x => x.hasError).length > 0) {
            setAssets(newAssets);
            return;
        }

        setAssets([
            ...newAssets,
            {
                id: crypto.randomUUID(),
                ...initialState
            }
        ]);
    }

    const onDelete = (e, id) => {
        e.stopPropagation();

        if (assets && assets.length === 1)
            return;

        const newAssets2 = assets.filter(asset => asset.id !== id);
        setAssets(newAssets2);
        toast.success('The asset has been successfully deleted.', { duration: 6000 });
    }

    const onChange = (currentIndex, value) => {
        const newAssets = assets.map((asset, index) => ({
            ...asset,
            assetId: currentIndex === index ? value : asset.assetId,
            hasError: currentIndex === index && value ? false : (currentIndex === index && value === "" ? true : asset.hasError)
        }));

        setAssets(newAssets);
    }

    return (
        <Grid container spacing={2} marginTop={"25px"} >
            {
                assets && assets.map((asset, index) => (
                    <Grid key={asset.id} item xs={12}>
                        <Accordion
                            variant='outlined'
                            expanded={asset.isOpen}
                            onChange={(e, isExpanded) => onExpand(index, isExpanded)}
                            TransitionProps={{ unmountOnExit: true }}
                            sx={{ marginBottom: '1%' }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Grid container direction='row'>
                                    <Grid item sx={10}>
                                        <Typography
                                            sx={{
                                                flexShrink: 0,
                                                color: Grey3,
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                fontFamily: trakrefFontFamilySemiBold,
                                                lineHeight: 2.5
                                            }}
                                        >
                                            Inventory # {index + 1}
                                        </Typography>
                                    </Grid>
                                    <Grid item sx={{ marginLeft: 'auto' }}>
                                        <Tooltip title="Delete">
                                            <IconButton
                                                onClick={(e) => onDelete(e, asset.id)}
                                                disabled={assets.length === 1}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Select
                                    required
                                    width={60}
                                    label="Inventory"
                                    value={asset.assetId}
                                    error={asset.hasError}
                                    options={options}
                                    onChange={e => onChange(index, e.target.value)}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                ))
            }

            <Grid item xs={12}>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    marginTop: "10px"
                }}>
                    <SecondaryButton
                        useSmallButton={true}
                        isTextVariant={true}
                        buttonText='Add New Asset'
                        onClick={onAdd}
                        startIcon={<AddIcon />}
                    />
                </div>
            </Grid>
        </Grid>
    )
};

export default Assets;